import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-panel" }
const _hoisted_2 = { class: "date-selector" }
const _hoisted_3 = { class: "date-selector-grid" }
const _hoisted_4 = {
  key: 0,
  class: "custom-dates"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "order-table" }
const _hoisted_8 = { class: "report-section" }
const _hoisted_9 = { class: "grid" }
const _hoisted_10 = { ref: "paidUsersLineChart" }
const _hoisted_11 = { ref: "valuePerUserLineChart" }
const _hoisted_12 = { class: "grid" }
const _hoisted_13 = { ref: "userBarChart" }
const _hoisted_14 = { ref: "ticketsBarChart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _cache[16] || (_cache[16] = _createElementVNode("h1", null, "Reporting", -1)),
      _createElementVNode("div", null, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "time-period-section" }, [
          _createElementVNode("div", null, "Summary")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "period" }, "Select Period:", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPeriod) = $event)),
                id: "period"
              }, _cache[6] || (_cache[6] = [
                _createStaticVNode("<option value=\"today\" data-v-3901c4bd>Today</option><option value=\"yesterday\" data-v-3901c4bd>Yesterday</option><option value=\"last7\" data-v-3901c4bd>Last 7 Days</option><option value=\"thisMonth\" data-v-3901c4bd>This Month</option><option value=\"lastMonth\" data-v-3901c4bd>Last Month</option><option value=\"yearToDate\" data-v-3901c4bd>Year to Date</option><option value=\"custom\" data-v-3901c4bd>Custom Range</option><option value=\"allTime\" data-v-3901c4bd>All Time</option>", 8)
              ]), 512), [
                [_vModelSelect, _ctx.selectedPeriod]
              ])
            ]),
            _createElementVNode("div", null, [
              (_ctx.selectedPeriod === 'custom')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("label", null, "Start Date:", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customStart) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.customStart]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", null, "End Date:", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customEnd) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.customEnd]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { for: "searchCompetition" }, "Search Competition:", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Search Competition",
                id: "searchCompetition",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchText) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchText]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { for: "period" }, "Competitions:", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCompetition) = $event)),
                id: "period"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCompetitions, (competition) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: competition.competitionId,
                    value: competition.competitionId
                  }, _toDisplayString("WSP" +
                    competition.competitionId +
                    " - " +
                    competition.competitionName), 9, _hoisted_5))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedCompetition]
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.loadCharts && _ctx.loadCharts(...args))),
              disabled: _ctx.isLoading
            }, "Apply", 8, _hoisted_6)
          ]),
          _createElementVNode("table", _hoisted_7, [
            _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "table-header" }, [
                _createElementVNode("th", null, "Key"),
                _createElementVNode("th", null, "Value")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData, (value, key) => {
                return (_openBlock(), _createElementBlock("tr", { key: key }, [
                  _createElementVNode("td", null, _toDisplayString(key), 1),
                  _createElementVNode("td", null, _toDisplayString(value), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[14] || (_cache[14] = _createElementVNode("h2", null, "Target Metrics", -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _createElementVNode("canvas", _hoisted_10, null, 512)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("canvas", _hoisted_11, null, 512)
          ])
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("h2", null, "Tickets & Users", -1)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createElementVNode("canvas", _hoisted_13, null, 512)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("canvas", _hoisted_14, null, 512)
          ])
        ])
      ])
    ])
  ]))
}